export default (theme) => ({
  pageContent: {
    marginLeft: 220,
    padding: 0,
    height: "100 %",
    overflow: "hidden",
  },
  menu: {
    position: "absolute",
    width: "160px",
    backgroundColor: "white",
    boxShadow: "0 0 5px grey",
    borderRadius: "3px",
    zIndex: "99"
  },
  menuItem: {
    width: "100%",
    backgroundColor: "white",
    border: "none",
    margin: "0",
    padding: "10px",
  },
  recordInfo: {
    position: "absolute",
    padding: 5,
    fontFamily: "Source Sans Pro,Source Sans Pro Regular,Source Sans Pro Bold",
    width: "300px",
    backgroundColor: "white",
    boxShadow: "0 0 5px grey",
    borderRadius: "3px",
    zIndex: "99"
  }
});
